import { NgModule } from "@angular/core";
import { ExcludeVisibleKeyPipe } from "./exclude-visible-key.pipe";

@NgModule({
    imports: [],
    exports: [ExcludeVisibleKeyPipe],
    declarations: [ExcludeVisibleKeyPipe],
    providers: [],
})
export class ExcludeVisibleKeyPipeModule { }